module.exports = __webpack_public_path__ + "static/img/item2.681a59a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/item2.png
// module id = yfAL
// module chunks = 0